import styled from 'styled-components';

import Button from 'components/shared/Button';
import { colors } from 'styles/theme/colors';
import { BodySmall } from 'styles/typography';

// The action for the payer-disambiguation state, in the slideout's pinned footer alongside every
// other primary action. It was a sticky bar at the end of the candidate list, which cannot sit at
// the bottom of a scrolling body that has padding — sticky positions against the padding box, so
// cards kept scrolling past in the strip below it.
interface Props {
  selectedId: string | null;
  onRun: () => void;
  isRunning: boolean;
}

export default function SelectPayerFooter({ selectedId, onRun, isRunning }: Props) {
  return (
    <>
      <Hint>{selectedId ? '' : 'A payer must first be selected to run an eligibility check'}</Hint>
      <Button
        disabled={!selectedId || isRunning}
        loading={isRunning}
        onClick={onRun}
        data-testid='run-eligibility-check'>
        Run Eligibility Check
      </Button>
    </>
  );
}

const Hint = styled(BodySmall)`
  color: ${colors.black50};
`;
